import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-styleguide',
  templateUrl: './styleguide.component.html',
})
export class StyleguideComponent implements OnInit {

    constructor(private titleService: Title) { }

    ngOnInit() {
        this.titleService.setTitle('Dermabase Styleguide');
    }
}



// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/frontend/styleguide/styleguide.component.ts